// src/utils/gridHelpers.js
export const snapToGrid = (value, gridSize) => Math.round(value / gridSize) * gridSize;

export const checkBoundaries = (element, canvasSize) => {
  return (
    element.x >= 0 &&
    element.y >= 0 &&
    element.x + element.width <= canvasSize.width &&
    element.y + element.height <= canvasSize.height
  );
};